import b_ from "b_";
// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__5dbY+","gwcspinner":"styles_gwcspinner__vzv0y","s":"styles_s__1NO6Y","m":"styles_m__4WFS7","l":"styles_l__M9hHq"};
export const b = b_.with('spinner');